import type seedrandom from 'seedrandom';

export type RngDistribution =
    | undefined
    | null
    | number
    | { lowerBound?: number; upperBound?: number; factor?: number }
    | ((x: number) => number);

export function parseRngDistribution(
    distribution?: RngDistribution
): (x: number) => number {
    if (!distribution) return (x) => x;
    if (typeof distribution === 'number') return (x) => x * distribution;
    if (typeof distribution === 'function') return distribution;
    if (typeof distribution === 'object') {
        const lowerBound = distribution.lowerBound ?? 0;
        const upperBound = distribution.upperBound ?? lowerBound + 1;
        const factor = distribution.factor ?? upperBound - lowerBound;
        return (x) => lowerBound + factor * x;
    }
    return (x) => x;
}

export type RngFn = (distribution?: RngDistribution) => number;

export function mapRngFunction(
    fn: () => number
): (distribution?: RngDistribution) => number {
    return (distr) => parseRngDistribution(distr)(fn());
}

export interface UniformRng {
    (max: number): number;
    (min: number, max: number): number;
}

export function makeUniformRng(base: seedrandom.PRNG): UniformRng {
    return (minOrMax: number, max?: number) =>
        max === undefined
            ? minOrMax * base.quick()
            : minOrMax + (max - minOrMax) * base.quick();
}
